export default "__VITE_ASSET__BUUmyUZM__"